<div class="row">
  <div class="col-sm-12">
    <section class="panel">
      <app-page-title title="Create Letterhead" [loading]="isLoading"></app-page-title>

      <div class="panel-body">
        <form class="form-horizontal" (ngSubmit)="create()" ngNativeValidate>
          <app-letterhead-form [letterhead]="letterhead" *ngIf="letterhead"></app-letterhead-form>
        </form>
      </div>
    </section>
  </div>
</div>


